// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate
/* eslint-disable no-template-curly-in-string */

export const callToAction = {
  call_to_action: {
    contentful_name: 'Call to Action (DEFAULT DO NOT CHANGE)',
    health_default: '选择健康计划',
    health_waived: '放弃保障',
    supplemental: '补充',
    continue_button: {
      hsa: '补充计划',
      review: '开始注册',
      profile: '健康结果',
      results: '继续',
      overview: '查看概览',
      viewPlan: '所有计划',
      viewBenefit: '所有福利',
      profileReview: '审阅模式',
    },
    tooltips: {
      hsa: '前往 HSA',
      profile: {
        claims: '当前支出',
        income: '收入',
        member: '家庭',
        hsaFunds: '当前储蓄',
        location: '居住地',
        pregnancy: '怀孕',
        enrollment: '注册',
        incentives: '激励',
        providerPreferences: '就医偏好',
        eligibility: '资格',
        utilization: '使用情况',
        prescription: '处方药',
        capacityToPay: '支付能力',
        riskAssessment: '保障偏好',
      },
      results: '前往健康',
      overview: '查看计划',
      employerContribution: '雇主将贡献最多 ${x}',
      continueButtonDisabled: '选择健康计划',
    },
    cart_header: '已选方案',
    cart_text: '以下是您目前选择的内容。点击计划可返回查看该计划的详细信息。',
    cart_close_button: '关闭',
    accessibility: {
      continue_button: '导航',
    },
  },
};
